import moment from "moment";

const fmtDate = v => (v ? moment(v).format("DD.MM.yyyy HH:mm") : "—");

export default {
  slug: "surveys",
  endpoint: "surveys/",
  titleKey: "surveys_title",
  columns: [
    { field: "title", label: "f_title" },
    { label: "f_active_from", format: row => fmtDate(row.active_from) },
    { label: "f_active_to", format: row => fmtDate(row.active_to) },
  ],
  fields: [
    { name: "title", type: "text", label: "f_title", required: true },
    { name: "description", type: "textarea", label: "f_description", wide: true },
    { name: "active_from", type: "datetime", label: "f_active_from", required: true },
    { name: "active_to", type: "datetime", label: "f_active_to", required: true },
    {
      name: "form_organization_mode", type: "select", label: "f_form_organization_mode",
      options: [
        { value: "products", label: "Products" },
        { value: "brands", label: "Brands" },
        { value: "categories", label: "Categories" },
        { value: "subcategories", label: "Subcategories" },
      ],
    },
    { name: "audience", type: "audience", label: "f_audience", wide: true },
    { name: "questions", type: "questions", label: "f_questions", wide: true },
  ],
  sections: [
    { title: "sec_basic", fields: ["title", "description"] },
    { title: "sec_schedule", fields: ["active_from", "active_to", "form_organization_mode"] },
    { title: "sec_audience", fields: ["audience"] },
    { title: "sec_questions", fields: ["questions"] },
  ],
  softDelete: true,
};
